import { SearchBaseModel } from '../commonModels';


export class CustomerSearchModel extends SearchBaseModel {
   public CustomerId: number;

   constructor() {
      super();
      this.CustomerId = null;
   }

}

export class CustomerDictionarySearchModel {
  public OnlyMy: boolean;
  public ShowExternalCustomers: boolean;
  public OnlyActive: boolean;
  public GarageId: number;
  public IsNewCarAvailableByGarage: boolean;
}
